'use strict';

var perfCascade = require('perf-cascade/dist/perf-cascade.min.js');

$('body').externalLinks();

document.querySelectorAll('.js-perfcascade-legend').forEach(function (element) {
  element.appendChild(perfCascade.makeLegend());
});

var options = {
  showIndicatorIcons: false,
  leftColumnWith: 30
};

$('.js-perfcascade-display-har').each(function (element) {
  var $this = $(this);
  var har = JSON.parse($this.html());
  var harSvg = perfCascade.fromHar(har, options);
  $this.replaceWith(harSvg);
});
